import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AlarmLimits } from "../actions/apiActions";

// Function for adding deviceName from deviceConfigs to fetched alarm data.
export const addDeviceNameToGetAllAlarmLimitsResponse = (data, devicesEntries) => {
  const mergedData = data.map((dataObject) => {
    const deviceInfo = devicesEntries.find((device) => device.hwId === dataObject.hwId);
    return {
      ...dataObject,
      name: deviceInfo ? deviceInfo.name : undefined,
    };
  });
  return mergedData;
};

export const alarmsLimitsDefaultState = {
  entries: [],
  formattedEntries: [],
};

// In this function we take all alarm limit objects (a list) and remove unnecessary ones (alarms with no limits)
// We also add frontendId property to the alarms
const formatAlarmLimitList = (allAlarmLimits) => {
  // example of an alarmLimit object
  //  {
  //   "hwId": "TEI_60i",
  //   "valueName": "ReferenceIntensity",
  //   "customerId": null,
  //   "deviceId": null,
  //   "lowWarning": 32000,
  //   "highWarning": 53000,
  //   "lowAlarm": 30000,
  //   "highAlarm": 55000
  // }
  let formattedList = [];
  allAlarmLimits.map((alarm) => {
    {
      if (!(alarm.lowWarning === null && alarm.highWarning === null && alarm.lowAlarm === null && alarm.highAlarm === null) &&
        !(alarm.lowWarning === undefined && alarm.highWarning === undefined && alarm.lowAlarm === undefined && alarm.highAlarm === undefined)) {
        alarm.frontendId = alarm.hwId + "|" + alarm.valueName;
        formattedList.push(alarm);
      }
    }
  });
  return formattedList;
};

export const getAllAlarmLimits = createAsyncThunk(
  "alarmsLimits/getAllAlarmLimits",
  async (params, thunk) => {
    const { systemId, solutionType } = params;
    const { config } = thunk.getState().config[systemId].system;
    console.log("config in getAllAlarmLimits", config);
    const devicesEntries = thunk.getState().config[systemId].devicesConfigs.entries;
    if (config) {
      const data =
        {
          CustomerId: config.CUSTOMER_ID,
          DeviceId: config.DEVICE_ID,
          isLoraDevice: solutionType === "lora" ? true : false,
        } || {};
      const response = await AlarmLimits.getAll(config.DATA_URL, data);
      console.log("response", response);
      return { response, devicesEntries, systemId };
    }
  }
);

export const restoreAlarmLimits = createAsyncThunk(
  "alarmsLimits/restoreAlarmLimits",
  async (params, thunk) => {
    const { systemId, HwId, ValueName } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      const option =
        {
          CustomerId: config.CUSTOMER_ID,
          DeviceId: config.DEVICE_ID,
          HwId: HwId,
          ValueName: ValueName,
        } || {};
      const response = await AlarmLimits.restore(config.DATA_URL, option);
      return { response, systemId };
    }
  }
);

const alarmsLimitsSlice = createSlice({
  name: "alarmsLimits",
  initialState: alarmsLimitsDefaultState,
  reducers: {
    updateReduxState(state, action) {
      const entries = Object.values(action.payload.saveState);
      state.formattedEntries = entries;
    },
    updateReduxStateAfterRestore(state, action) {
      let oldState = action.payload.formState;
      let restoredLimits = action.payload.response.limits;
      let restoredAlarmFrontendId = restoredLimits.hwId + "|" + restoredLimits.valueName;
      let alarmToBeRestored = oldState.filter(
        (alarmToBeRestored) => alarmToBeRestored.frontendId === restoredAlarmFrontendId
      ); // to check if the alarm if found from state
      if (alarmToBeRestored) {
        let newAlarms = oldState.map((alarm, idx) => {
          let newAlarm = { ...alarm };
          if (alarm.frontendId === restoredAlarmFrontendId) {
            Object.keys(newAlarm).forEach((key) => {
              // loop trough alarms' values..
              if (restoredLimits[key]) {
                // ... if restoredValues contain the same key as looped alarms' key e.g. "lowWarning" ...
                newAlarm[key] = restoredLimits[key]; // ... update its value
              }
            });
          }
          return newAlarm;
        });
        state.formattedEntries = newAlarms;
        console.log("state after restore", state);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAlarmLimits.fulfilled, (state, action) => {
      const data = action.payload.response.allAlarms;
      const devicesEntries = action.payload.devicesEntries;
      const dataWithDeviceNames = addDeviceNameToGetAllAlarmLimitsResponse(data, devicesEntries);
      state.entries = dataWithDeviceNames;
      state.formattedEntries = formatAlarmLimitList(dataWithDeviceNames);
    });
  },
});

export const { updateReduxState, updateReduxStateAfterRestore } = alarmsLimitsSlice.actions;

export default alarmsLimitsSlice.reducer;
